;(function() {
  'use strict'

  angular.module('core.services').factory('rewardFactory', service)

  /* @ngInject */
  function service() {
    var defaultImage = './img/reward-icon.png'

    return {
      transform: transform,
    }

    function transform(data) {
      if (!_.isArray(data)) {
        data = [data]
      }
      _.each(data, function(reward) {
        var extras = {}
        var mEndAt = moment(reward.endAt)
        var mUsedOn = moment(reward.usedOnDate)
        extras.imageUrl = reward.imageUrl || defaultImage
        if (reward.type === 'donation') {
          extras.subtext = 'Donated on ' + mEndAt.format('Do MMM YYYY')
          extras.state = 'donated'
        } else if (reward.usedOnDate) {
          mUsedOn = moment(reward.usedOnDate)
          extras.subtext = 'Used on ' + mUsedOn.format('Do MMM YYYY')
          extras.state = 'used'
        } else if (isExpired(reward.endAt)) {
          mEndAt = moment(reward.endAt)
          extras.subtext = 'Expired ' + mEndAt.format('Do MMM YYYY')
          extras.state = 'expired'
        } else {
          mEndAt = moment(reward.endAt)
          extras.subtext = 'Expires ' + mEndAt.format('Do MMM YYYY')
          extras.state = 'notExpired'
          extras.canUse = true
        }
        reward.extras = extras
      })
      sort(data)
    }

    function sort(rewards) {
      var copy = _.clone(rewards)
      var types = {
        notExpired: [],
        donated: [],
        expired: [],
        used: [],
      }
      _.each(copy, function(reward) {
        types[reward.extras.state].push(reward)
      })
      // sort 'em
      types.notExpired = _.sortBy(types.notExpired, sortEndAt)
      types.donated = _.sortBy(types.donated, sortEndAt)
      types.expired = _.sortBy(types.expired, sortEndAt)
      types.used = _.sortBy(types.used, sortUsedOn)
      // refill
      var all = types.notExpired
        .concat(types.donated)
        .concat(types.expired)
        .concat(types.used)
      angular.copy(rewards, all)

      function sortUsedOn(reward) {
        return moment(reward.usedOnDate).unix() || 0
      }

      function sortEndAt(reward) {
        return moment(reward.endAt).unix() || 0
      }
    }

    function isExpired(date) {
      var mDate = moment(date)
      var mNow = moment()
      return mNow.isAfter(mDate)
    }
  }
})()
